var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 3.3,
    width: 13.75,
    height: 10.1,
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3 7h13.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2 10.7h2.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e32c46f1692449a1b28abcf9b00bccd7.svg";
export { ForwardRef as ReactComponent };